import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import userReducer from '@appblocks/frontend/redux/userSlice';
import debugReducer from '@appblocks/frontend/redux/debugSlice';
import messagesReducer, { messagesMiddleware } from '@appblocks/frontend/redux/messagesSlice';
import projectReducer from '@appblocks/frontend/redux/projectSlice';
import pagesReducer from '@appblocks/frontend/redux/pagesSlice';
import workflowReducer from '@appblocks/frontend/redux/workflowSlice';
import workspacesReducer from '@appblocks/frontend/redux/workspacesSlice';
import pageAppReducer from '@appblocks/frontend/redux/pageAppSlice';
import {
    messagesMiddleware as messagesListenerMiddleware,
    pagesMiddleware,
} from '@appblocks/frontend/redux/listeners';
import userMiddleware from '@appblocks/frontend/redux/listeners/userMiddleware';
import debugMiddleware from '@appblocks/frontend/redux/listeners/debugMiddleware';
import projectMiddleware from '@appblocks/frontend/redux/listeners/projectMiddleware';
import workspaceMiddleware from '@appblocks/frontend/redux/listeners/workspaceMiddleware';
import pageAppMiddleware from '@appblocks/frontend/redux/listeners/pageAppMiddleware';


export default configureStore({
    reducer: {
        debug: debugReducer,
        messages: messagesReducer,
        user: userReducer,
        projectData: projectReducer,
        pages: pagesReducer,
        workspaces: workspacesReducer,
        pageApp: pageAppReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .prepend(messagesListenerMiddleware.middleware)
        .prepend(messagesMiddleware)
        .prepend(projectMiddleware.middleware)
        .prepend(pagesMiddleware.middleware)
        .prepend(debugMiddleware.middleware)
        .prepend(userMiddleware.middleware)
        .prepend(pagesMiddleware.middleware)
        .prepend(workspaceMiddleware.middleware)
        .prepend(pageAppMiddleware.middleware),
    devTools: true,
});
